var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', [_vm._v(" " + _vm._s(_vm.$t("components.PartnerReportDetail.repair.PartnerReportCostEstimateCard.title", {
    count: _vm.report.repairEstimates.length
  })) + " "), _c('v-spacer'), _c('v-btn', {
    staticClass: "mx-2",
    attrs: {
      "outlined": "",
      "disabled": !_vm.canCreateRepairEstimate || !_vm.canShareContent
    },
    on: {
      "click": function click($event) {
        _vm.requestDialog = true;
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-open-in-new")]), _vm._v(" " + _vm._s(_vm.$t("components.PartnerReportDetail.repair.PartnerReportCostEstimateCard.requestEstimate")) + " ")], 1), _c('v-btn', {
    attrs: {
      "elevation": "0",
      "disabled": !_vm.canCreateRepairEstimate
    },
    on: {
      "click": function click($event) {
        _vm.createDialog = true;
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-tray-arrow-up")]), _vm._v(" " + _vm._s(_vm.$t("components.PartnerReportDetail.repair.PartnerReportCostEstimateCard.uploadEstimate")) + " ")], 1)], 1), _vm.report.isRepairEstimateLoading ? _c('v-skeleton-loader', {
    staticClass: "mx-4 mb-4",
    attrs: {
      "type": "image"
    }
  }) : _vm.report.repairEstimates.length === 0 ? _c('v-card-text', [_c('m-no-content', {
    attrs: {
      "icon": "mdi-file-document-outline",
      "text": _vm.$t('components.PartnerReportDetail.repair.PartnerReportCostEstimateCard.noEstimatesText')
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function fn() {
        return [_c('v-btn', {
          staticClass: "mx-2 px-4",
          attrs: {
            "outlined": "",
            "disabled": !_vm.canCreateRepairEstimate || !_vm.canShareContent
          },
          on: {
            "click": function click($event) {
              _vm.requestDialog = true;
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "left": ""
          }
        }, [_vm._v("mdi-open-in-new")]), _vm._v(" " + _vm._s(_vm.$t("components.PartnerReportDetail.repair.PartnerReportCostEstimateCard.requestEstimate")) + " ")], 1), _c('v-btn', {
          staticClass: "mx-2 px-4",
          attrs: {
            "elevation": "0",
            "disabled": !_vm.canCreateRepairEstimate
          },
          on: {
            "click": function click($event) {
              _vm.createDialog = true;
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "left": ""
          }
        }, [_vm._v("mdi-tray-arrow-up")]), _vm._v(" " + _vm._s(_vm.$t("components.PartnerReportDetail.repair.PartnerReportCostEstimateCard.uploadEstimate")) + " ")], 1)];
      },
      proxy: true
    }])
  })], 1) : _c('div', {
    staticClass: "mx-4"
  }, [_c('v-divider'), _c('v-tabs', {
    staticClass: "custom-tabs",
    attrs: {
      "background-color": "transparent",
      "show-arrows": "",
      "slider-color": "transparent",
      "active-class": "custom-tab--active"
    },
    model: {
      value: _vm.activeEstimate,
      callback: function callback($$v) {
        _vm.activeEstimate = $$v;
      },
      expression: "activeEstimate"
    }
  }, _vm._l(_vm.report.repairEstimates, function (estimate, index) {
    var _estimate$timestamp;

    return _c('v-tab', {
      key: 'tab-' + index,
      attrs: {
        "value": index
      }
    }, [_vm._v(" " + _vm._s((estimate.number || "#" + (index + 1)) + ((_estimate$timestamp = estimate.timestamp) !== null && _estimate$timestamp !== void 0 && _estimate$timestamp.createdReadable ? " (" + estimate.timestamp.createdReadable + ")" : "")) + " ")]);
  }), 1), _c('v-sheet', {
    attrs: {
      "color": _vm.$vuetify.theme.dark ? 'grey darken-3' : 'grey lighten-4'
    }
  }, [_c('v-card-text', [_c('v-tabs-items', {
    model: {
      value: _vm.activeEstimate,
      callback: function callback($$v) {
        _vm.activeEstimate = $$v;
      },
      expression: "activeEstimate"
    }
  }, _vm._l(_vm.report.repairEstimates, function (_, index) {
    return _c('v-tab-item', {
      key: 'tab-content-' + index,
      attrs: {
        "value": index
      }
    }, [_c('repair-estimate-sheet', {
      attrs: {
        "estimate": _vm.report.repairEstimates[index],
        "report": _vm.report
      },
      on: {
        "update:estimate": function updateEstimate($event) {
          return _vm.$set(_vm.report.repairEstimates, index, $event);
        },
        "delete": function _delete($event) {
          return _vm.removeFromReport(index);
        }
      }
    })], 1);
  }), 1)], 1)], 1)], 1), _c('report-repair-estimate-request-dialog', {
    model: {
      value: _vm.requestDialog,
      callback: function callback($$v) {
        _vm.requestDialog = $$v;
      },
      expression: "requestDialog"
    }
  }), _c('report-repair-estimate-create-dialog', {
    model: {
      value: _vm.createDialog,
      callback: function callback($$v) {
        _vm.createDialog = $$v;
      },
      expression: "createDialog"
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }